import StatusIndicator from "../../../../../components/fundamentals/status-indicator";
import Table from "../../../../../components/fundamentals/table";
import { Order } from "../../../../../models/Order";
import { AgencieStrapi } from "../../../../../models/strapi/AgencieStrapi.model";
import DateHelper from "../../../../../models/utils/DateHelper";
import PriceHelper from "../../../../../models/utils/PriceHelper";

interface IProps {
  order: Order;
  index: number;
  showColClient?: boolean;
  showStatus?: boolean;
  agencies?: AgencieStrapi[];
}
export default function OrderRow({ order, index, showColClient = true, showStatus = false, agencies }: IProps) {
  const getBgEntreprise = () => {
    if (index % 3 === 0) return "bg-orange-40";
    else if (index % 2 === 0) return "bg-pink-40";
    else return "bg-fuschia-40";
  };

  // Etat d'avancement vers l'ERP, lisible, pour la page « Commandes Plateforme ».
  const getStatus = (): { title: string; variant: "warning" | "danger" | "success" | "default" } => {
    switch (order.status) {
      case Order.STATUS_PENDING_ERP:
        return { title: "En attente ERP", variant: "warning" };
      case Order.STATUS_ERROR:
        return { title: "Erreur ERP", variant: "danger" };
      case Order.STATUS_SUCCESS:
        return { title: "Transmise à l'ERP", variant: "success" };
      default:
        return { title: "Enregistrée", variant: "default" };
    }
  };

  return (
    <Table.Row linkTo={`/orders/${order.id}`} color={"inherit"}>
      <Table.Cell>
        <div className="flex items-center gap-x-2">
          <span>#{order.id}</span>
          {/* RAG-52 : repère des commandes Plateforme Socoda en attente / en erreur ERP. */}
          {order.status === Order.STATUS_PENDING_ERP && (
            <StatusIndicator title="En attente ERP" variant="warning" />
          )}
          {order.status === Order.STATUS_ERROR && (
            <StatusIndicator title="Erreur ERP" variant="danger" />
          )}
        </div>
      </Table.Cell>
      <Table.Cell>
        {DateHelper.dateToDDMMYYYYAndHM(order.created_at)}
      </Table.Cell>
      {showColClient && <Table.Cell>
        <div className="flex items-center">
          <div className="w-[24px] h-[24px]">
            <span
              className={`w-full h-full items-center justify-center overflow-hidden select-none rounded-circle ${getBgEntreprise()}`}
            >
              <span className="w-full h-full flex items-center justify-center bg-inherit text-grey-0 rounded-circle inter-small-semibold">
                {order.client.name.charAt(0)}
              </span>
            </span>
          </div>
          <span className="ml-2">{order.client.name}</span>
        </div>
      </Table.Cell> }
      <Table.Cell>{order?.getPickUpAddress(agencies ?? []) ?? "-"} </Table.Cell>
      <Table.Cell>{PriceHelper.price2Digits(order.total_amount)} €</Table.Cell>
      {showStatus && (
        <Table.Cell>
          <StatusIndicator title={getStatus().title} variant={getStatus().variant} />
        </Table.Cell>
      )}
      {/* <Table.Cell>
        <StatusIndicator
          title={order.status == "request" ? "Actif" : "Non actif"}
          variant={order.status == "request" ? "active" : "default"}
        />
      </Table.Cell> */}
    </Table.Row>
  );
}
